import { render, staticRenderFns } from "./h5Invite.vue?vue&type=template&id=1306f3d0&scoped=true&"
import script from "./h5Invite.vue?vue&type=script&lang=js&"
export * from "./h5Invite.vue?vue&type=script&lang=js&"
import style0 from "./h5Invite.vue?vue&type=style&index=0&id=1306f3d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306f3d0",
  null
  
)

export default component.exports